/* global axios */
import ApiClient from './ApiClient';

class InboxMembers extends ApiClient {
  constructor() {
    super('inbox_members', { accountScoped: true });
  }

  // Wholesale replace of an inbox's agent list (server diffs add/remove).
  // Routed as `PATCH /inbox_members/:inbox_id` (member route, with `param:
  // :inbox_id` declared in routes.rb). The collection PATCH used to 404
  // silently because :update wasn't in the resources `only:` list.
  update({ inboxId, agentList }) {
    return axios.patch(`${this.url}/${inboxId}`, {
      inbox_id: inboxId,
      user_ids: agentList,
    });
  }
}

export default new InboxMembers();
